import { render } from "./DocumentViewWithToolbar.vue?vue&type=template&id=21e164fc&scoped=true"
import script from "./DocumentViewWithToolbar.vue?vue&type=script&lang=js"
export * from "./DocumentViewWithToolbar.vue?vue&type=script&lang=js"

import "./DocumentViewWithToolbar.vue?vue&type=style&index=0&id=21e164fc&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e164fc"]])

export default __exports__